import {Injectable, OnInit} from '@angular/core';
import {HttpService} from './http.service';
import {GetCustomerCategoryResponseDto} from '../models/GetCustomerCategoryResponseDto';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {SessionStorageService} from './session-storage.service';

@Injectable()
export class CustomerCategoriesService implements OnInit {

    customerCategoriesCacheKey = 'customerCategories';

    constructor(private httpService: HttpService, private sessionStorageService: SessionStorageService) {
    }

    ngOnInit(): void {
    }

    getAll(): Observable<Array<GetCustomerCategoryResponseDto>> {
        const customerCategories = this.sessionStorageService.get(this.customerCategoriesCacheKey);
        if (customerCategories != null) {
            return Observable.of(customerCategories);
        } else {
            return Observable.create(observer => {
                const url = environment.ENDPOINTS.GET_ALL_CUSTOMER_CATEGORIES;
                this.httpService.getJson<Array<GetCustomerCategoryResponseDto>>(url).subscribe(response => {
                    this.sessionStorageService.set(this.customerCategoriesCacheKey, response.body);
                    observer.next(response.body);
                    observer.complete();
                });
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/customer-categories.service.ts